import React, { Component, useEffect, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StatusBar,
  ScrollView,
  Alert,
  ImageBackground,
  Platform,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";

import { StackActions, NavigationActions } from "react-navigation";
import styles from "./styles";
import {
  candidatarVaga,
  dispensarVaga,
  getAluno,
  listarVagas,
} from "../../services/aluno-service";
import Toast from "react-native-tiny-toast";
import { EventRegister } from "react-native-event-listeners";

import ConfirmarDados from "../../components/ConfirmarDados";
import CardVaga from "../../components/CardVaga";
import colors from "../../styles/colors";

const ListaVagas = ({ mostrarConfirm, vagas, loading, navigation }) => {
  return (
    <>
      <View style={[styles.personalData]}>
        <View style={styles.header}>
          <Text style={[styles.textHeader, { marginBottom: 5 }]}>
            Novas Vagas
          </Text>
        </View>
        <View style={styles.body}>
          {loading ? (
            <Text style={{ fontFamily: "Montserrat", color: colors.text }}>
              Carregando...
            </Text>
          ) : vagas.novas.length === 0 ? (
            <Text
              style={{
                fontFamily: "Montserrat",
                textAlign: "center",
                color: "#C1C1C1",
              }}
            >
              Nenhuma nova vaga para o seu perfil.
            </Text>
          ) : (
            vagas.novas.map((v) => (
              <CardVaga
                key={v.id}
                vaga={v}
                mostrarConfirm={() => mostrarConfirm(v.id)}
                irParaDetalhes={() => navigation.push("Vaga", { vaga: v })}
              />
            ))
          )}
        </View>
      </View>
      <View style={[styles.personalData]}>
        <View style={styles.header}>
          <Text style={[styles.textHeader]}>Candidaturas</Text>
        </View>
        <View style={styles.body}>
          {loading ? (
            <Text style={{ fontFamily: "Montserrat", color: colors.text }}>
              Carregando...
            </Text>
          ) : vagas.candidatadas.length === 0 ? (
            <Text
              style={{
                fontFamily: "Montserrat",
                textAlign: "center",
                color: "#c1c1c1",
              }}
            >
              Você ainda não tem nenhuma candidatura.
            </Text>
          ) : (
            vagas.candidatadas.map((v) => (
              <CardVaga
                key={v.id}
                vaga={v}
                mostrarConfirm={() => mostrarConfirm(v.id)}
                irParaDetalhes={() => navigation.push("Vaga", { vaga: v })}
              />
            ))
          )}
        </View>
      </View>
    </>
  );
};

function Vagas({ navigation }) {
  const [idModalConfirm, setIdModalConfirm] = useState(0);
  const [vagas, setVagas] = useState({
    novas: [],
    candidatadas: [],
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const buscarVagas = async () => {
      try {
        const response = await listarVagas();

        if (!response.ok) return console.log(await response.json());

        setVagas(await response.json());

        setLoading(false);
      } catch (e) {
        console.error(e);
      }
    };

    const listener = EventRegister.addEventListener(
      "reloadVagas",
      async (data) => {
        buscarVagas();
      }
    );

    const listenerCandidatura = EventRegister.addEventListener(
      "reloadCandidaturas",
    async (vagaId) => {
        const [vagaAux] = vagas.novas.filter((v) => v.id === vagaId);

        if (vagaAux) {
          vagaAux.status = 2;

          setVagas({
            ...vagas,
            novas: vagas.novas.filter((v) => v.id !== vagaId),
            candidatadas: [vagaAux, ...vagas.candidatadas],
          });
        }
      }
    );

    buscarVagas();

    return function limpar() {
      EventRegister.removeEventListener(listener);
      EventRegister.removeEventListener(listenerCandidatura);
    };
  }, []);

  const candidatarSe = async () => {
    try {
      const response = await candidatarVaga(idModalConfirm);

      if (!response.ok) return console.log(await response.json());

      const [vagaAux] = vagas.novas.filter((v) => v.id === idModalConfirm);

      vagaAux.status = 2;

      setVagas({
        ...vagas,
        novas: vagas.novas.filter((v) => v.id !== idModalConfirm),
        candidatadas: [vagaAux, ...vagas.candidatadas],
      });

      setIdModalConfirm(0);

      Toast.show("Candidatura Realizada. Aguarde o contato da empresa.");
    } catch (e) {
      console.error(e);
    }
  };

  const dispensar = async (vagaId) => {
    try {
      const response = await dispensarVaga(vagaId);

      if (!response.ok) return console.log(await response.json());

      setIdModalConfirm(0);

      Toast.show("Vaga dispensada.");

      setVagas({
        ...vagas,
        novas: vagas.novas.filter((v) => v.id !== idModalConfirm),
      });

      navigation.pop(1);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      {idModalConfirm !== 0 && (
        <ConfirmarDados
          fechar={() => setIdModalConfirm(0)}
          dispensar={() => {
            if (
              Platform.OS === "web" &&
              window.confirm("Deseja realmente dispensar essa oportunidade?")
            )
              dispensar(idModalConfirm);
            else
              Alert.alert(
                "Confirmar",
                "Deseja realmente dispensar essa oportunidade?",
                [
                  {
                    text: "Sim",
                    onPress: () => dispensar(idModalConfirm),
                  },
                  {
                    text: "Não",
                    style: "cancel",
                  },
                ]
              );
          }}
          confirmar={candidatarSe}
        />
      )}
      <ImageBackground
        source={require("../../../resources/imgs/bg.jpg")}
        style={[styles.container]}
        imageStyle={styles.imageContainer}
      >
        <ScrollView
          style={[styles.container, { height: 100, paddingVertical: 10 }]}
        >
          <ListaVagas
            vagas={vagas}
            loading={loading}
            mostrarConfirm={setIdModalConfirm}
            navigation={navigation}
          />
        </ScrollView>
      </ImageBackground>
    </>
  );
}

Vagas.navigationOptions = ({ navigation }) => {
  return {
    headerStyle: {
      backgroundColor: "#0F0F0F",
    },
    headerTitleStyle: {
      color: "#FFF",
    },
    headerTitle: "Minhas Vagas",
    headerLeft: () => (
      <TouchableOpacity
        onPress={() => {
          navigation.openDrawer();
        }}
      >
        <Icon
          style={styles.iconHeaderLeft}
          name="reorder"
          size={30}
          color="#F1F1F1"
        />
      </TouchableOpacity>
    ),
    headerRight: () => (
      <TouchableOpacity
        onPress={() => {
          EventRegister.emitEvent("reloadVagas");
        }}
      >
        <Icon
          style={[styles.iconBarRight, { marginRight: 10 }]}
          name="refresh"
          size={20}
          color="#F1F1F1"
        />
      </TouchableOpacity>
    ),
  };
};

export default Vagas;
